import { render, staticRenderFns } from "./AmortizationReport.vue?vue&type=template&id=6b79a852&"
import script from "./AmortizationReport.vue?vue&type=script&lang=ts&"
export * from "./AmortizationReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b79a852')) {
      api.createRecord('6b79a852', component.options)
    } else {
      api.reload('6b79a852', component.options)
    }
    module.hot.accept("./AmortizationReport.vue?vue&type=template&id=6b79a852&", function () {
      api.rerender('6b79a852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-payables/reports/AmortizationReport.vue"
export default component.exports